import TableText from "@/components/table/TableText";
import { calculation, numConvert, sum } from "@/method";
import { setKarte, setOption } from '@/method/analysis';
import request from '@/method/request';
import _ from 'lodash';
import moment from "moment";
import React from "react";


export default (data, { date, data1_1, data7_1, data7_1_2 }) => {

    // 数据链接2022-02开始
    const isOpenLastFill = moment(date).isBefore(moment("2022-02"));
    if (!isOpenLastFill) {
        data[5].actual = numConvert(_.get(data7_1_2, "0.thisy_employee_num", 0), 2);
        data[7].actual = numConvert(_.get(data7_1_2, "0.thisy_payroll_cost", 0), 2);
        data[9].actual = numConvert(_.get(data7_1_2, "1.thisy_employee_num", 0), 2);
        data[11].actual = numConvert(_.get(data7_1_2, "1.thisy_payroll_cost", 0), 2);
        data[13].actual = numConvert(_.get(data7_1_2, "6.thisy_employee_num", 0), 2);
        data[15].actual = numConvert(_.get(data7_1_2, "6.thisy_payroll_cost", 0), 2);
        data[17].actual = sum([
            _.get(data7_1_2, "2.thisy_employee_num", 0),
            _.get(data7_1_2, "3.thisy_employee_num", 0),
            _.get(data7_1_2, "4.thisy_employee_num", 0),
            _.get(data7_1_2, "5.thisy_employee_num", 0)
        ], 2);
        data[19].actual = sum([
            _.get(data7_1_2, "2.thisy_payroll_cost", 0),
            _.get(data7_1_2, "3.thisy_payroll_cost", 0),
            _.get(data7_1_2, "4.thisy_payroll_cost", 0),
            _.get(data7_1_2, "5.thisy_payroll_cost", 0)
        ], 2);
        data[21].actual = numConvert(_.get(data7_1, "10.thisy_employee_num", 0), 2);
    }

    // 人效指数
    data[25].actual = calculation(
        _.get(data1_1, "8.actual"), sum([_.get(data7_1, "16.thisy_payroll_cost"), _.get(data7_1, "19.thisy_payroll_cost")]), 2
    );
    data[25].last = calculation(
        _.get(data1_1, "8.last_year"), sum([_.get(data7_1, "16.lasty_payroll_cost"), _.get(data7_1, "19.lasty_payroll_cost")]), 2
    );

    data[26].actual = calculation(
        _.get(data1_1, "6.actual"), sum([_.get(data7_1, "17.thisy_payroll_cost"), _.get(data, "10.actual")]), 2
    );
    data[26].last = calculation(
        _.get(data1_1, "6.last_year"), sum([_.get(data7_1, "17.lasty_payroll_cost"), _.get(data, "10.last")]), 2
    );

    data[27].actual = calculation(
        _.get(data1_1, "5.actual"), sum([_.get(data7_1, "18.thisy_payroll_cost"), _.get(data, "6.actual")]), 2
    );
    data[27].last = calculation(
        _.get(data1_1, "5.last_year"), sum([_.get(data7_1, "18.lasty_payroll_cost"), _.get(data, "6.last")]), 2
    );

    //劳动生产率
    data[29].actual = calculation(
        _.get(data1_1, "6.actual"), _.get(data, "9.actual"), 2
    );
    data[29].last = calculation(
        _.get(data1_1, "6.last_year"), _.get(data, "9.last"), 2
    );

    data[30].actual = calculation(
        _.get(data1_1, "5.actual"), _.get(data, "5.actual"), 2
    );
    data[30].last = calculation(
        _.get(data1_1, "5.last_year"), _.get(data, "5.last"), 2
    );

    data.forEach((item, i) => {
        data[i].contrast = calculation(item.actual - item.last, item.last, 4);
    });

    return data
}

const totalIndex = [0, 4, 8, 12, 16, 20, 24, 28];
export const columns = (onChange, print, date) => {
    const isOpenLastFill = moment(date).isBefore(moment("2022-02"));
    let openIndex = [5, 7, 9, 11, 13, 15, 17, 19, 21];
    if (isOpenLastFill) openIndex = []; 
    return [
        {
            title: '',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 400,
            render: (text, record, index) => {
                const title = [];
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 4
                    },
                    children: <TableText data={props} />
                }
                return <TableText data={props} />
            }
        },
        {
            title: `今年当月实际`,
            dataIndex: 'actual',
            key: 'actual',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['今年当月实际'];
                const props = {
                    text,
                    index,
                    type: !totalIndex.includes(index) && !openIndex.includes(index) && !print && index < 24 ? 'inputNumber' : 'number',
                    name: "actual",
                    onChange,
                    totalIndex,
                };
                props.compared = {
                    title,
                    record,
                    sqlName: "_7_7"
                }
                if (!totalIndex.includes(index)) return <TableText data={props} />
                return {
                    props: {
                        colSpan: 0
                    }
                }
            }
        },
        {
            title: `去年当月实际`,
            dataIndex: 'last',
            key: 'last',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['去年当月实际'];
                const props = {
                    text,
                    index,
                    type: !totalIndex.includes(index) && !print && index < 24 && isOpenLastFill ? 'inputNumber' : 'number',
                    name: "last",
                    onChange,
                    totalIndex,
                };
                props.compared = {
                    title,
                    record,
                    sqlName: "_7_7"
                }

                if (!totalIndex.includes(index)) return <TableText data={props} />
                return {
                    props: {
                        colSpan: 0
                    }
                }
            }
        },
        {
            title: ``,
            dataIndex: 'contrast',
            key: 'contrast',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = [];
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "contrast",
                    onChange,
                    totalIndex,
                };
                props.compared = {
                    title,
                    record,
                    sqlName: "_7_7"
                }

                if (!totalIndex.includes(index)) return <TableText data={props} />
                return {
                    props: {
                        colSpan: 0
                    }
                }
            }
        }
    ]
}

export const getChart = async year => {
    const { data } = await request(`/chartData?year=${year}`);
    const dataX = new Array(12).fill(1).map((x, i) => `${i + 1}月`);
    const xAxis = [{
        type: 'category',
        axisLabel: {
            color: "black",
            fontSize: 14,
            rotate: 40,
            interval: 0,
        },
        data: new Array(12).fill(1).map((x, i) => `${year}-${i + 1}`)
    }, {
        type: 'category',
        axisLabel: {
            color: "black",
            interval: 0,
            rotate: 40,
            fontSize: 14,
        },
        data: new Array(12).fill(1).map((x, i) => `${year - 1}-${i + 1}`)
    }];
    setKarte({
        id: "row1",
        title: "去年人效指数",
        color: ['#00C5BD', '#42585D', '#FE5F5F'],
        yAxis: {
            max: 5, min: 0, interval: 0.5
        },
        dataX, dataY: [
            {
                name: "酒店数据",
                data: dataX.map((x, i) => numConvert(_.get(data.peopleWork.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            },
            {
                name: "区域数据",
                data: dataX.map((x, i) => numConvert(_.get(data.area.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            },
            {
                name: "收入区间数据",
                data: dataX.map((x, i) => numConvert(_.get(data.interval.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
            }
        ]
    });
    setKarte({
        id: "row2",
        title: "当年人效指数",
        color: ['#00C5BD', '#42585D', '#FE5F5F'],
        yAxis: {
            max: 5, min: 0, interval: 0.5
        },
        dataX, dataY: [
            {
                name: "酒店数据",
                data: dataX.map((x, i) => numConvert(_.get(data.peopleWork.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            },
            {
                name: "区域数据",
                data: dataX.map((x, i) => numConvert(_.get(data.area.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            },
            {
                name: "收入区间数据",
                data: dataX.map((x, i) => numConvert(_.get(data.interval.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
            }
        ]
    });
    setOption({
        id: "chart1", title: "酒店整体人效指数", dataX,
        xAxis,
        yAxis: {
            max: 5, min: 0, interval: 0.5
        },
        dataY: [{
            name: `${year} 当年`,
            data: dataX.map((x, i) => numConvert(_.get(data.peopleWork.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
        }, {
            name: `${year - 1} 去年`,
            data: dataX.map((x, i) => numConvert(_.get(data.peopleWork.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
        }]
    });
    setOption({
        id: "chart2", title: "后台人力成本占比", dataX,
        xAxis,
        yAxis: {
            max: 1, min: 0, interval: 0.1
        },
        dataY: [{
            name: `${year} 当年`,
            data: dataX.map((x, i) => calculation(_.get(data.humanCost.find(_x => _x.month == (i + 1)), 'actual', 0), _.get(data.data7_1.find(_x => _x.month == (i + 1)), 'actual', 0)))
        }, {
            name: `${year - 1} 去年`,
            data: dataX.map((x, i) => calculation(_.get(data.humanCost.find(_x => _x.month == (i + 1)), 'last', 0), _.get(data.data7_1.find(_x => _x.month == (i + 1)), 'last', 0)))
        }]
    });

    setOption({
        id: "chart3", title: "Rooms 人效指数", dataX,
        xAxis,
        yAxis: {
            max: 10, min: 0, interval: 1
        },
        dataY: [{
            name: `${year} 当年`,
            data: dataX.map((x, i) => numConvert(_.get(data.roomH.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
        }, {
            name: `${year - 1} 去年`,
            data: dataX.map((x, i) => numConvert(_.get(data.roomH.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
        }]
    });
    setOption({
        id: "chart4", title: "Rooms劳动生产率", dataX,
        xAxis,
        yAxis: {
            max: 80000, min: 0, interval: 10000
        },
        dataY: [{
            name: `${year} 当年`,
            type: "bar",
            data: dataX.map((x, i) => numConvert(_.get(data.roomP.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
        }, {
            name: `${year - 1} 去年`,
            type: "bar",
            data: dataX.map((x, i) => numConvert(_.get(data.roomP.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
        }]
    });

    setOption({
        id: "chart5", title: "F&B人效指数", dataX,
        xAxis,
        yAxis: {
            max: 10, min: 0, interval: 1
        },
        dataY: [{
            name: `${year} 当年`,
            data: dataX.map((x, i) => numConvert(_.get(data.fbH.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
        }, {
            name: `${year - 1} 去年`,
            data: dataX.map((x, i) => numConvert(_.get(data.fbH.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
        }]
    });
    setOption({
        id: "chart6", title: "F&B劳动生产率", dataX,
        xAxis,
        yAxis: {
            max: 80000, min: 0, interval: 10000
        },
        dataY: [{
            name: `${year} 当年`,
            type: "bar",
            data: dataX.map((x, i) => numConvert(_.get(data.fbP.find(_x => _x.month == (i + 1)), 'actual', 0)).toFixed(2))
        }, {
            name: `${year - 1} 去年`,
            type: "bar",
            data: dataX.map((x, i) => numConvert(_.get(data.fbP.find(_x => _x.month == (i + 1)), 'last', 0)).toFixed(2))
        }]
    });
}


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-7/compute.js